import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ContactRestService} from '../../../shared/services/contact/contact-rest.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'wsd-verify-contact-mail',
  templateUrl: './verify-contact-mail.component.html',
  styleUrls: ['./verify-contact-mail.component.css']
})
export class VerifyContactMailComponent implements OnInit, OnDestroy {

  private routeSub: Subscription;

  message: string;

  constructor(private route: ActivatedRoute,
              private contactRestService: ContactRestService,
              private router: Router,
              private translate: TranslateService) { }

  ngOnInit() {
    this.routeSub = this.route.params.subscribe(
      (params: Params) => this.checkToken(params)
    );
  }

  private checkToken(params: Params) {
    if (params['token']) {
      this.contactRestService.verifyEmaiAddress(params['token']).subscribe(
        (data: string) => {
          this.message = this.translate.instant('VERIFY_CONTACT_MAIL_MSG', {email: data});
        },
        (err: any) => {
          this.router.navigate(['contacts']);
        }
      );
    } else {
      this.router.navigate(['contacts']);
    }
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

}
